/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiBulkRateSkippedIdentity } from '../models/ApiBulkRateSkippedIdentity';
import { HttpFile } from '../http/http';

export class ApiBulkRateResponse {
    'skipped': Array<ApiBulkRateSkippedIdentity>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "skipped",
            "baseName": "skipped",
            "type": "Array<ApiBulkRateSkippedIdentity>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiBulkRateResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

